import CookiesPopup from './CookiesPopup';

export default CookiesPopup;
